 
import React, { useContext, useEffect, useState } from 'react';
import SuccessModal from '../SuccessModal';
import { useNavigate } from 'react-router-dom';
import { getSelectedTabListPickupView, getSelectedTabListView, getUserData, setSelectedTabListPickupView } from '../../utils/localStorage';
import { postStoreRiderJobPickupOrDelivery } from '../../services/StoreRiderInfo/StoreRiderInfo';
import JobRequests from './JobRequests';
import StatusFilterModal from '../StatusFilterModal';
import TabMenu from '../TabMenu';
import StoreMenu from '../StoreMenu';
import ButtonLink from '../../ButtonLink';
import JobRequestsListView from './JobRequestsListView';
import { getBrandStore } from '../../services/StoreUsers/PostStoreUsers';
import { FloatLabel } from 'primereact/floatlabel';
import { Dropdown } from 'primereact/dropdown';
import AdminMenu from '../AdminMenu';
import { localeDateEndDate, localeDateStartDate } from '../../constants/DateUtil/DateUtil';
import SupportAdminMenu from '../SupportAdminMenu';

const { innerWidth: width, innerHeight: height } = window;


const DeliveryJobAdmin = () => {
  const navigate = useNavigate();
  
  
    const { userProfileRole, brandProfileData } = getUserData();
    const userRole = userProfileRole;
    let brandId = brandProfileData.id;

   const [assignStoreValue, setAssignStoreValue] = useState("");
    const [storeId, setStoreId] = useState(null);
  
    const handleAssignStoreChange = (selectedItem) => {
      setAssignStoreValue(selectedItem);
      const data = {
        startDate: localeDateStartDate(new Date(startDate)),
        endDate: localeDateEndDate(new Date(endDate)),
        jobStatus: [
          'DELIVERY_REQ',
          'ASSIGNED_TO_RIDER',
          'RESCHEDULE_BY_CUSTOMER',
          'RESCHEDULE_BY_RIDER',
          'OUT_FOR_DELIVERY',
        ],
      };
      fetchRiderJobDeliveryData(data, selectedItem);
      setStoreId(selectedItem);
    };
  

  const [visible, setVisible] = useState(false);

  const jobType = 'delivery';

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 15); // subtract 7 days to current date

  const [startDate, setStartDate] = useState(new Date(initialStartDate));

  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [showStartDatePicker, setShowStartDatePicker] = useState(false);
  const [showEndDatePicker, setShowEndDatePicker] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [focusedField, setFocusedField] = useState('');
  const [isLoading, setIsLoading] = useState(false); // New state for loading indicator
  const [isGetJobButtonPressed, setIsGetJobButtonPressed] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('ALL');

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth() - 120); //

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date

  const [tabularView, setTabularView] = useState(false);
    
      const handleTabListViewChange = async (selectedType) => {
        setTabularView(selectedType);
        await setSelectedTabListPickupView(selectedType);
      };
  

      const fetchSelectedTabListView = async () => {
          try {
            const selectedInvoiceTypeData = await getSelectedTabListPickupView();
            setTabularView(selectedInvoiceTypeData?.tabListPickupView || "list");
          } catch {
            setTabularView("list");
          }
        };

  const [orderInfoData, setOrderInfoData] = useState([]);
  const [todayOrderData, setTodayOrderData] = useState([]);
  const [storeData, setStoreData] = useState([]);

   const fetchStoreUser = () => {
      getBrandStore(brandId)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const newRes = Res.map((item) => ({
              name: item.storeName,
              value: item.id,
            }));
            setStoreData(newRes);
            // fetchStoreRiderInfo(Res[0].id);
            // setStoreId(Res[0].id);
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    };
  

  const fetchRiderJobDeliveryData = (data, storeId) => {
    postStoreRiderJobPickupOrDelivery(storeId, jobType, data)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          setTodayOrderData(Res);
        }
      })
      .catch(err => {
        console.error('Rider Job Error:', err);
      });
  };

  useEffect(() => {
    fetchStoreUser();
    fetchSelectedTabListView()
  }, []);

  const callRequestApi = () => {
    const data = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      jobStatus: [
        'DELIVERY_REQ',
        'ASSIGNED_TO_RIDER',
        'RESCHEDULE_BY_CUSTOMER',
        'RESCHEDULE_BY_RIDER',
        'OUT_FOR_DELIVERY',
      ],
    };
    fetchRiderJobDeliveryData(data, storeId);
    fetchSelectedTabListView()
  };

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const receiveDataFromStatusFilterModal = selectedStatus => {
    handleConfirmDelivery(selectedStatus)
  };

  const handleConfirmDelivery = (selectedStatus) => {
    // Create a new delivery request object
    setIsLoading(true);
    if (!isGetJobButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsGetJobButtonPressed(true);
      setTimeout(() => {
        setIsLoading(false);

        const data = {
          startDate: localeDateStartDate(new Date(startDate)),
          endDate: localeDateEndDate(new Date(endDate)),
          jobStatus:
            selectedStatus !== 'ALL'
              ? selectedStatus
              : [
                'DELIVERY_REQ',
                'ASSIGNED_TO_RIDER',
                'RESCHEDULE_BY_CUSTOMER',
                'RESCHEDULE_BY_RIDER',
                'OUT_FOR_DELIVERY',
              ],
        };
        fetchRiderJobDeliveryData(data, storeId);
        setIsGetJobButtonPressed(false);
        fetchSelectedTabListView()
        // Reset the form fields
        let initialStartDate = new Date();
        setStartDate(new Date(initialStartDate));

        let initialEndDate = new Date();
        // Set the minimumDate for the end date picker
        setEndDate(initialEndDate);
      }, 1000); // Replace with actual async operation duration
    }
  };

  return (
    <div className="flex-1">
    <div
      className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
      style={{
        "--surface-0": "#1752AA",
      }}
    >
      <div className="flex-1 flex ml-3 mr-3">
        <div className="flex-1 flex ">
          <div className="ml-3 flex justify-content-center align-items-center">
            <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">              
              <i className="pi pi-angle-left" onClick={() => navigate(-1)} style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}></i>
            </div>
          </div>
          <div className="flex-1 ml-5">
            <p className="text-white text-2xl font-bold ">
              Delivery Job
            </p>
          </div>
        </div>

          {storeId && 
            <>
            <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#55BD5A",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>

        <div
          onClick={() => handleFilterModal("DELIVERED")}
          className="mx-2 cursor-pointer"
        >
          <img
            src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
            style={{ width: height < 600 ? 25 : 30 }}
          />
        </div>
          </>
}
        <div
          className="flex justify-content-center align-items-center cursor-pointer"
          onClick={() => setVisible(true)}
        >
          <i
            className="pi pi-bars"
            style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
          ></i>
        </div>
      </div>
    </div>

     <div className="flex flex-row">
            <div className="mt-4 mb-3 mx-4 flex-1">
              <FloatLabel>
                <Dropdown
                  id="assignStoreValue"
                  value={assignStoreValue}
                  onChange={(e) => handleAssignStoreChange(e.target.value)}
                  options={storeData}
                  optionLabel="name"
                  placeholder="Store"
                  className="w-full border-round-xl  text-2xl text-xl shadow-2"
                />
                <label
                  htmlFor="assignStoreValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Store <span style={{ color: "red" }}>*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
    
       
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={'Added'}
          text={'Your Amount is added successfully.'}
        />
         <StatusFilterModal
          setStatusFilterModalVisible={setStatusFilterModalVisible}
          statusFilterModalVisible={statusFilterModalVisible}
          sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
          upDateSelectedStatus={upDateSelectedStatus}
          OrderStatus={[
           'DELIVERY_REQ',
                'ASSIGNED_TO_RIDER',
                'RESCHEDULE_BY_CUSTOMER',
                'RESCHEDULE_BY_RIDER',
                'OUT_FOR_DELIVERY',
          ]}
          />

      {tabularView === "tab" && (
        <div
          className="scroll-bar mb-2"
          style={{
            height: height - 80,
            overflowY: "scroll",
          }}
        >
          <JobRequestsListView
            orderInfoData={todayOrderData}
            JobType={jobType}
            storeId={storeId}
            callRequestApi={callRequestApi}
          />
        </div>
      )}

          <div style={{ display: tabularView === "tab" ? "none" : "" }}>
        <JobRequests
            orderInfoData={todayOrderData}
            JobType={jobType}
            storeId={storeId}
            callRequestApi={callRequestApi}
          />
      </div>
      {/* <TabMenu  /> */}
       {userRole === "BY_SUPPORT_ADMIN" ? 
              <SupportAdminMenu setVisible={setVisible} visible={visible} />
              :
              <AdminMenu setVisible={setVisible} visible={visible} />
            }
            
      <ButtonLink />
    </div>
  );
};

export default DeliveryJobAdmin;
 